//#region Imports
import React, { useState, useEffect, useRef } from 'react';
import { StyleSheet, Platform, SafeAreaView, FlatList, View, useWindowDimensions } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { useAccountContext } from '../../../hooks/useAccountContext';
import CustomButton from '../../../components/CustomButton';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import HRAdminCategoriesScreen from '../HRAdminTrainings/HRAdminCategoriesScreen';
import HRAdminSubjectScreen from '../HRAdminTrainings/HRAdminSubjectScreen';
import HRAdminTrainingsScreen from '../HRAdminTrainings/HRAdminTrainingsScreen';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import HRAdminTrainingDetailsScreen from '../HRAdminTrainings/HRAdminTrainingDetailsScreen';
import { useTraining } from '../../../hooks/useTraining';
import HRAdminLAndDScreen from '../HRAdminTrainings/HRAdminLAndDScreen';
import RoleGuard from '../../../components/RoleGuard';
import { TASKS, TASK_OPTIONS } from '../../../constants/Tasks';

const HRAdminPageTrainings = () => {
    //#region Const Definitions and UseRef and UseState
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions();
    const { account } = useAccountContext();
    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const buttonTable = [0, 1, 2, 3];
    const { loadCategories, loadSubjects, deleteLAndDNeed, saveLAndDNeed, loadLAndDNeed,
        loadLAndDMethod, saveLAndDMethod, deleteLAndDMethod
    } = useTraining();

    const [showCategoriesScreen, setShowCategoriesScreen] = useState(0);
    const [showSubjectScreen, setShowSubjectScreen] = useState(0);
    const [showTrainingsScreen, setShowTrainingsScreen] = useState(1);
    const showTrainingsScreenRef = useRef(0);
    const [showTrainingDetailsScreen, setShowTrainingDetailsScreen] = useState(0);
    const [showLAndDNeedScreen, setShowLAndDNeedScreen] = useState(0);
    const [showLAndDMethodScreen, setShowLAndDMethodScreen] = useState(0);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedTraining, setSelectedTraining] = useState({});
    const [categories, setCategories] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [trnData, setTRNData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);

    //#region SubMenu Listeners
    const setAllPagesToZero = () => {
        setShowCategoriesScreen(0);
        setShowSubjectScreen(0);
        setShowTrainingsScreen(0);
        setShowTrainingDetailsScreen(0);
        setShowLAndDNeedScreen(0);
        setShowLAndDMethodScreen(0);
    }

    const pressedOnCategories = () => {
        setAllPagesToZero();
        setShowCategoriesScreen(1);
    }

    const pressedOnSubject = () => {
        setAllPagesToZero();
        setShowSubjectScreen(1);
    }

    const pressedOnTrainings = () => {
        setAllPagesToZero();
        setShowTrainingsScreen(1);
    }

    const pressedOnTrainingDetails = () => {
        setAllPagesToZero();
        setShowTrainingDetailsScreen(1);
    }

    const pressedOnLAndDNeed = () => {
        setAllPagesToZero();
        setShowLAndDNeedScreen(1);
    }

    const pressedOnLAndDMethod = () => {
        setAllPagesToZero();
        setShowLAndDMethodScreen(1);
    }

    //#region UseEffect
    useEffect(() => {
        setAllPagesToZero();
        setShowTrainingsScreen(1);
        Promise.all([loadCategories(), loadSubjects()])
            .then(([categories, subjects]) => {
                setCategories(categories);
                setSubjects(subjects);
            })
            .catch(() => {
                setRefreshAfterSave(false);
                setIsLoading(false);
            });

        if (Platform.OS === "web") {
            checkIfRefreshed()
                .then(() => { })
                .catch(console.error);
        }
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            try {
                localStorage.setItem(
                    "showTrainingsScreen",
                    showTrainingsScreenRef.current
                );
                localStorage.setItem("isRefresh", "true");
                localStorage.setItem("lastVisitedScreen", "HRAdminPageTrainings");
            } catch (error) {
                console.log(error.message);
            }
        };
        if (Platform.OS === "web") {
            window.addEventListener("beforeunload", handleBeforeUnload);
            return () => {
                window.removeEventListener("beforeunload", handleBeforeUnload);
            };
        }
    }, [account]);

    //* if refreshed, get data from session storage,
    //* to show same page as before refresh
    const checkIfRefreshed = async () => {
        try {
            let isRefresh = localStorage.getItem("isRefresh");
            if (isRefresh === "true") {
                setShowTrainingsScreen(
                    parseInt(localStorage.getItem("showTrainingsScreen"))
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => { }, [width, height]);

    //#region Assign UseRef
    useEffect(() => {
        showTrainingsScreenRef.current = showTrainingsScreen;
    }, [showTrainingsScreen]);
    //#endregion
    //#endregion


    return (
        <SafeAreaView style={styles.main}>
            {/* Tabs Row */}
            <View>
                <FlatList
                    horizontal
                    showsHorizontalScrollIndicator={true}
                    directionalLockEnabled={true}
                    alwaysBounceVertical={false}
                    data={buttonTable}
                    contentContainerStyle={{
                        alignSelf: "flex-start",
                        marginBottom: "1%",
                    }}
                    showsVerticalScrollIndicator={true} //shows horizontal scroll bar on web
                    renderItem={({ index }) => {
                        return (
                            <SafeAreaView>
                                {index == 0 && (
                                    <RoleGuard parentTask={TASKS.TRAINING} task={TASK_OPTIONS.TRAIN} table='hr' requireCRUD>
                                        <CustomButton
                                            onPress={() => {
                                                if (showTrainingsScreen) return;
                                                pressedOnTrainings();
                                            }}
                                            text={t("navigate:training")}
                                            iconName="file-tray-full-outline"
                                            show={showTrainingsScreen || showTrainingDetailsScreen ? "HOME_SELECTED" : "HOME"}
                                            type={showTrainingsScreen || showTrainingDetailsScreen ? "HOME_SELECTED" : "HOME"}
                                            textTop="0"
                                            isGradient={showTrainingsScreen || showTrainingDetailsScreen ? true : false}
                                            sz={Platform.OS !== "web" ? 20 : 25}
                                        />
                                    </RoleGuard>
                                )}
                                {index == 1 && (
                                    <RoleGuard parentTask={TASKS.TRAINING} task={TASK_OPTIONS.CATEGORIES} table='hr' requireCRUD>
                                        <CustomButton
                                            onPress={() => {
                                                if (showCategoriesScreen) return;
                                                pressedOnCategories();
                                            }}
                                            text={t("navigate:trnCategories") + ' - ' + t("navigate:trnSubjects")}
                                            iconName="file-tray-full-outline"
                                            show={showCategoriesScreen || showSubjectScreen ? "HOME_SELECTED" : "HOME"}
                                            type={showCategoriesScreen || showSubjectScreen ? "HOME_SELECTED" : "HOME"}
                                            textTop="0"
                                            isGradient={showCategoriesScreen || showSubjectScreen ? true : false}
                                            sz={Platform.OS !== "web" ? 20 : 25}
                                        />
                                    </RoleGuard>
                                )}
                                {index == 2 && (
                                    <RoleGuard parentTask={TASKS.TRAINING} task={TASK_OPTIONS.LM} table='hr' requireCRUD>
                                        <CustomButton
                                            onPress={() => {
                                                if (showLAndDNeedScreen) return;
                                                pressedOnLAndDNeed();
                                            }}
                                            text={t("navigate:trnLAndDNeed")}
                                            iconName="file-tray-full-outline"
                                            show={showLAndDNeedScreen ? "HOME_SELECTED" : "HOME"}
                                            type={showLAndDNeedScreen ? "HOME_SELECTED" : "HOME"}
                                            textTop="0"
                                            isGradient={showLAndDNeedScreen ? true : false}
                                            sz={Platform.OS !== "web" ? 20 : 25}
                                        />
                                    </RoleGuard>
                                )}
                                {index == 3 && (
                                    <RoleGuard parentTask={TASKS.TRAINING} task={TASK_OPTIONS.LMM} table='hr' requireCRUD>
                                        <CustomButton
                                            onPress={() => {
                                                if (showLAndDMethodScreen) return;
                                                pressedOnLAndDMethod();
                                            }}
                                            text={t("navigate:trnLAndDMethod")}
                                            iconName="file-tray-full-outline"
                                            show={showLAndDMethodScreen ? "HOME_SELECTED" : "HOME"}
                                            type={showLAndDMethodScreen ? "HOME_SELECTED" : "HOME"}
                                            textTop="0"
                                            isGradient={showLAndDMethodScreen ? true : false}
                                            sz={Platform.OS !== "web" ? 20 : 25}
                                        />
                                    </RoleGuard>
                                )}
                            </SafeAreaView>
                        );
                    }}
                    keyExtractor={(item) => `${item}`}
                />
            </View>

            {/* Views to show depending on Flatlist Selection */}
            {showTrainingsScreen ? (
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t("navigate:Trainings")}
                        type="MINORTITLE"
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminTrainingsScreen
                            subjects={subjects}
                            categories={categories}
                            setIsEdit={setIsEdit}
                            setSelectedTraining={setSelectedTraining}
                            pressedOnTrainingDetails={pressedOnTrainingDetails}
                            setTRNData={setTRNData}
                            trnData={trnData}
                        />
                    </SafeAreaView>
                </SafeAreaView>
            ) : (
                <></>
            )}
            {showTrainingDetailsScreen ? (
                <SafeAreaView style={[styles.main]}>
                    <SafeAreaView style={{ flexDirection: 'row' }}>
                        <TouchableOpacity onPress={() => { pressedOnTrainings() }} style={styles.backButton}>
                            <Ionicons name="arrow-back" size={30} color="black" />
                        </TouchableOpacity>
                        <CustomLabel
                            value={t("navigate:trnDetails") + ' - ' + (selectedTraining.title ? selectedTraining.title : "")}
                            type="MINORTITLE"
                        />
                    </SafeAreaView>
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminTrainingDetailsScreen
                            pressedOnTrainingDetails={pressedOnTrainingDetails}
                            selectedTraining={selectedTraining}
                            setSelectedTraining={setSelectedTraining}
                            trnOptions={trnData}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            trnData={trnData}
                        />
                    </SafeAreaView>
                </SafeAreaView>
            ) : (
                <></>
            )}
            {showCategoriesScreen ? (
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t("navigate:trnCategories")}
                        type="MINORTITLE"
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminCategoriesScreen
                            pressedOnSubject={pressedOnSubject}
                            setShowSubjectLines={setShowSubjectScreen}
                            showSubjectLines={showSubjectScreen}
                            selectedCategory={selectedCategory}
                            setSelectedCategory={setSelectedCategory}
                        />
                    </SafeAreaView>
                </SafeAreaView>
            ) : (
                <></>
            )}
            {showSubjectScreen ? (
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t("navigate:trnCategories") + ' | ' + t("navigate:trnSubjects")}
                        type="MINORTITLE"
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminSubjectScreen
                            selectedData={selectedCategory}
                            goBack={pressedOnCategories}
                        />
                    </SafeAreaView>
                </SafeAreaView>
            ) : (
                <></>
            )}
            {showLAndDNeedScreen ? (
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t("navigate:trnLAndDNeed")}
                        type="MINORTITLE"
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminLAndDScreen
                            loadData={loadLAndDNeed}
                            saveData={saveLAndDNeed}
                            deleteData={deleteLAndDNeed}
                        />
                    </SafeAreaView>
                </SafeAreaView>
            ) : (
                <></>
            )}
            {showLAndDMethodScreen ? (
                <SafeAreaView style={[styles.main]}>
                    <CustomLabel
                        value={t("navigate:trnLAndDMethod")}
                        type="MINORTITLE"
                    />
                    <SafeAreaView style={[styles.subMain]}>
                        <HRAdminLAndDScreen
                            loadData={loadLAndDMethod}
                            saveData={saveLAndDMethod}
                            deleteData={deleteLAndDMethod}
                        />
                    </SafeAreaView>
                </SafeAreaView>
            ) : (
                <></>
            )}
        </SafeAreaView>
    );
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
    },
    mainSubTabs: {
        zIndex: 2000,
        flexDirection: "row",
        alignSelf: 'flex-start',
        marginBottom: '1%',
    },
    subMain: {
        flex: 1,
        marginVertical: 10,
        marginHorizontal: 30,
    },
    row: {
        flexDirection: "row",
    },
    backButton: {
        alignSelf: 'flex-start',
        margin: 10,
        marginBottom: 0
    },
});

export default HRAdminPageTrainings; 